import { h } from '@stencil/core';
export class RangeWebinarsAndResourcesTab {
  constructor() {
    this.webinarAndResources = undefined;
  }
  render() {
    return (h("div", { class: "webinars-and-resources-sdl-content range-webinars-and-resources-tab__sdl-content" }, h("pes-sdl-content", { sdlHtmlContent: this.webinarAndResources.sdlContent })));
  }
  static get is() { return "pes-range-webinars-and-resources-tab"; }
  static get originalStyleUrls() {
    return {
      "$": ["range-webinars-and-resources-tab.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["range-webinars-and-resources-tab.css"]
    };
  }
  static get properties() {
    return {
      "webinarAndResources": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TWebinarAndResourcesData",
          "resolved": "{ sdlContent?: string; }",
          "references": {
            "TWebinarAndResourcesData": {
              "location": "import",
              "path": "../types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      }
    };
  }
  static get elementRef() { return "el"; }
}
